export default __webpack_public_path__ + "media/images/manual/joanr/17-b1db537b6a3804f3fc1a0972ab6762a7.png";